import { Http } from '@angular/http';
import { Component } from '@angular/core';
import { NavController, LoadingController, PopoverController, NavParams, ModalController, ToastController, AlertController } from 'ionic-angular';
import firebase from 'firebase/app';
import { AngularFirestore } from 'angularfire2/firestore';
import { LoadingProvider } from '../../providers/loading/loading';
import { ViewChangeLogPage } from '../view-change-log/view-change-log';

@Component({
  selector: 'page-change-log',
  templateUrl: 'change-log.html',
})
export class ChangeLogPage {
  public email: any;
  public uid: any;
  public count: any;
  public secondary_uid: any;
  public firstname: any;
  public lastname: any;
  public getRole: any;
  public usersList : any = [];
  data: any;
  public loading: any;
  public contactTotal: number;
  public innerJoinDocument: any;
  public deleted_access: any;

  constructor(
    public navCtrl: NavController,
    public db: AngularFirestore,
    public loadingProvider: LoadingProvider,
    public loadingCtrl: LoadingController,
    public popoverCtrl: PopoverController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public http: Http,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController
  ) {
    
    
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChangeLogPage');
    window.localStorage.removeItem("contact_uid");
    window.localStorage.removeItem("contact_second_uid");
    window.localStorage.removeItem("edit_contact_uid");
    window.localStorage.removeItem("deleted_access");
    window.localStorage.removeItem("generate_new_tentative");
    window.localStorage.removeItem("creating_second");

    let thiss = this;
    this.email = window.localStorage.getItem("email");
    this.uid = window.localStorage.getItem("uid");

    var docRef = firebase.firestore().collection("users").doc(this.uid);

    docRef.get().then(function(doc) {
      if (doc.exists) {
        console.log(doc.data());
        thiss.presentLoadingText();
        thiss.getAllLogs().subscribe((data)=>{
          for(let i = 0; i < data.length; i++) {
            if(data[i].uid == "" || data[i].uid == null || data[i].uid == undefined){}else{
              var docRef1 = firebase.firestore().collection("users").doc(data[i].uid);
              docRef1.get().then(function(doc) {
                if (doc.exists) {
                  data[i].name = doc.data().firstname+' '+doc.data().lastname;
                  if(doc.data().roles.broker == true){
                    data[i].c_type = 'Broker';
                  }else if(doc.data().roles.loan_admin == true){
                    data[i].c_type = 'Loan Admin';
                  }else if(doc.data().roles.super_admin == true){
                    data[i].c_type = 'Super Admin';
                  }else{
                    data[i].c_type = 'Contact';
                  }
                } else {
                  console.log("No such document!");
                }
              }).catch(function(error) {
                console.log("Error getting document:", error);
              });
            }
          }
          thiss.loading.dismiss();
          thiss.data = data;
          thiss.contactTotal = data.length;
        });
        
      }
    }).catch(function(error) {
      console.log("Error getting document:", error);
    });
  }
  presentLoadingText(){
    this.loading = this.loadingCtrl.create({
      content: 'Loading Please Wait...'
    });
    this.loading.present();
  }
  getAllLogs (){
    return this.db.collection<any>( "changed_log" , ref => ref.orderBy('changed_date','desc')).valueChanges ();
  }
  viewChangedData(event, document_id){
    this.navCtrl.push(ViewChangeLogPage,{
      document_id:document_id
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/change-log/change-log.ts